document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.media-slider').forEach(function (el) {
    var autoplayEnabled = el.dataset.autoplay === 'true';
    var navigationEnabled = el.dataset.navigation === 'true';

    var config = {
      speed: parseInt(el.dataset.speed, 10) || 600,
      loop: el.dataset.loop === 'true',
      freeMode: el.dataset.freemode === 'true',
      spaceBetween: parseInt(el.dataset.spaceBetween, 10) || 0,
      slidesPerView: parseFloat(el.dataset.slidesPerView) || 1,
      breakpoints: {
        0: {
          slidesPerView: parseFloat(el.dataset.slidesPerViewMobile) || 1
        },
        750: {
          slidesPerView: parseFloat(el.dataset.slidesPerView) || 1
        }
      }
    };

    if (navigationEnabled) {
      config.navigation = {
        nextEl: el.querySelector('.media-slider__arrow--next'),
        prevEl: el.querySelector('.media-slider__arrow--prev')
      };
    }

    if (autoplayEnabled) {
      config.autoplay = {
        delay: parseInt(el.dataset.autoplayDelay, 10) || 3000,
        disableOnInteraction: false
      };
    }

    new Swiper(el, config);
  });
});